// Generated by purs version 0.11.6
"use strict";
var $foreign = require("./foreign");
var React = require("../React");
var y = $foreign.unsafeMkProps("y");
var x = $foreign.unsafeMkProps("x");
var wrap = $foreign.unsafeMkProps("wrap");
var wmode = $foreign.unsafeMkProps("wmode");
var width = $foreign.unsafeMkProps("width");
var vocab = $foreign.unsafeMkProps("vocab");
var viewBox = $foreign.unsafeMkProps("viewBox");
var value = $foreign.unsafeMkProps("value");
var useMap = $foreign.unsafeMkProps("useMap");
var unselectable = $foreign.unsafeMkProps("unselectable");
var $$typeof = $foreign.unsafeMkProps("typeof");
var title = $foreign.unsafeMkProps("title");
var target = $foreign.unsafeMkProps("target");
var tabIndex = $foreign.unsafeMkProps("tabIndex");
var suppressContentEditableWarning = $foreign.unsafeMkProps("suppressContentEditableWarning");
var summary = $foreign.unsafeMkProps("summary");
var style = $foreign.unsafeUnfoldProps("style");
var strokeWidth = $foreign.unsafeMkProps("strokeWidth");
var stroke = $foreign.unsafeMkProps("stroke");
var step = $foreign.unsafeMkProps("step");
var start = $foreign.unsafeMkProps("start");
var srcSet = $foreign.unsafeMkProps("srcSet");
var srcLang = $foreign.unsafeMkProps("srcLang");
var srcDoc = $foreign.unsafeMkProps("srcDoc");
var src = $foreign.unsafeMkProps("src");
var spellCheck = $foreign.unsafeMkProps("spellCheck");
var span = $foreign.unsafeMkProps("span");
var sizes = $foreign.unsafeMkProps("sizes");
var size = $foreign.unsafeMkProps("size");
var shape = $foreign.unsafeMkProps("shape");
var selected = $foreign.unsafeMkProps("selected");
var security = $foreign.unsafeMkProps("security");
var seamless = $foreign.unsafeMkProps("seamless");
var scrolling = $foreign.unsafeMkProps("scrolling");
var scoped = $foreign.unsafeMkProps("scoped");
var scope = $foreign.unsafeMkProps("scope");
var sandbox = $foreign.unsafeMkProps("sandbox");
var rows = $foreign.unsafeMkProps("rows");
var rowSpan = $foreign.unsafeMkProps("rowSpan");
var role = $foreign.unsafeMkProps("role");
var reversed = $foreign.unsafeMkProps("reversed");
var results = $foreign.unsafeMkProps("results");
var resource = $foreign.unsafeMkProps("resource");
var required = $foreign.unsafeMkProps("required");
var rel = $foreign.unsafeMkProps("rel");
var readOnly = $foreign.unsafeMkProps("readOnly");
var radioGroup = $foreign.unsafeMkProps("radioGroup");
var r = $foreign.unsafeMkProps("r");
var property = $foreign.unsafeMkProps("property");
var profile = $foreign.unsafeMkProps("profile");
var preload = $foreign.unsafeMkProps("preload");
var prefix = $foreign.unsafeMkProps("prefix");
var poster = $foreign.unsafeMkProps("poster");
var points = $foreign.unsafeMkProps("points");
var placeholder = $foreign.unsafeMkProps("placeholder");
var pattern = $foreign.unsafeMkProps("pattern");
var optimum = $foreign.unsafeMkProps("optimum");
var open = $foreign.unsafeMkProps("open");
var opacity = $foreign.unsafeMkProps("opacity");
var onWheel = function (f) {
    return $foreign.unsafeMkProps("onWheel")(React.handle(f));
};
var onTransitionEnd = function (f) {
    return $foreign.unsafeMkProps("onTransitionEnd")(React.handle(f));
};
var onTouchStart = function (f) {
    return $foreign.unsafeMkProps("onTouchStart")(React.handle(f));
};
var onTouchMove = function (f) {
    return $foreign.unsafeMkProps("onTouchMove")(React.handle(f));
};
var onTouchEnd = function (f) {
    return $foreign.unsafeMkProps("onTouchEnd")(React.handle(f));
};
var onTouchCancel = function (f) {
    return $foreign.unsafeMkProps("onTouchCancel")(React.handle(f));
};
var onSubmit = function (f) {
    return $foreign.unsafeMkProps("onSubmit")(React.handle(f));
};
var onScroll = function (f) {
    return $foreign.unsafeMkProps("onScroll")(React.handle(f));
};
var onPaste = function (f) {
    return $foreign.unsafeMkProps("onPaste")(React.handle(f));
};
var onMouseUp = function (f) {
    return $foreign.unsafeMkProps("onMouseUp")(React.handle(f));
};
var onMouseOver = function (f) {
    return $foreign.unsafeMkProps("onMouseOver")(React.handle(f));
};
var onMouseOut = function (f) {
    return $foreign.unsafeMkProps("onMouseOut")(React.handle(f));
};
var onMouseMove = function (f) {
    return $foreign.unsafeMkProps("onMouseMove")(React.handle(f));
};
var onMouseLeave = function (f) {
    return $foreign.unsafeMkProps("onMouseLeave")(React.handle(f));
};
var onMouseEnter = function (f) {
    return $foreign.unsafeMkProps("onMouseEnter")(React.handle(f));
};
var onMouseDown = function (f) {
    return $foreign.unsafeMkProps("onMouseDown")(React.handle(f));
};
var onLoad = function (f) {
    return $foreign.unsafeMkProps("onLoad")(React.handle(f));
};
var onKeyUp = function (f) {
    return $foreign.unsafeMkProps("onKeyUp")(React.handle(f));
};
var onKeyPress = function (f) {
    return $foreign.unsafeMkProps("onKeyPress")(React.handle(f));
};
var onKeyDown = function (f) {
    return $foreign.unsafeMkProps("onKeyDown")(React.handle(f));
};
var onInvalid = function (f) {
    return $foreign.unsafeMkProps("onInvalid")(React.handle(f));
};
var onInput = function (f) {
    return $foreign.unsafeMkProps("onInput")(React.handle(f));
};
var onFocus = function (f) {
    return $foreign.unsafeMkProps("onFocus")(React.handle(f));
};
var onDrop = function (f) {
    return $foreign.unsafeMkProps("onDrop")(React.handle(f));
};
var onDragStart = function (f) {
    return $foreign.unsafeMkProps("onDragStart")(React.handle(f));
};
var onDragOver = function (f) {
    return $foreign.unsafeMkProps("onDragOver")(React.handle(f));
};
var onDragLeave = function (f) {
    return $foreign.unsafeMkProps("onDragLeave")(React.handle(f));
};
var onDragExit = function (f) {
    return $foreign.unsafeMkProps("onDragExit")(React.handle(f));
};
var onDragEnter = function (f) {
    return $foreign.unsafeMkProps("onDragEnter")(React.handle(f));
};
var onDragEnd = function (f) {
    return $foreign.unsafeMkProps("onDragEnd")(React.handle(f));
};
var onDrag = function (f) {
    return $foreign.unsafeMkProps("onDrag")(React.handle(f));
};
var onDoubleClick = function (f) {
    return $foreign.unsafeMkProps("onDoubleClick")(React.handle(f));
};
var onCut = function (f) {
    return $foreign.unsafeMkProps("onCut")(React.handle(f));
};
var onCopy = function (f) {
    return $foreign.unsafeMkProps("onCopy")(React.handle(f));
};
var onClick = function (f) {
    return $foreign.unsafeMkProps("onClick")(React.handle(f));
};
var onChange = function (f) {
    return $foreign.unsafeMkProps("onChange")(React.handle(f));
};
var onBlur = function (f) {
    return $foreign.unsafeMkProps("onBlur")(React.handle(f));
};
var onAnimationStart = function (f) {
    return $foreign.unsafeMkProps("onAnimationStart")(React.handle(f));
};
var onAnimationIteration = function (f) {
    return $foreign.unsafeMkProps("onAnimationIteration")(React.handle(f));
};
var onAnimationEnd = function (f) {
    return $foreign.unsafeMkProps("onAnimationEnd")(React.handle(f));
};
var nonce = $foreign.unsafeMkProps("nonce");
var noValidate = $foreign.unsafeMkProps("noValidate");
var name = $foreign.unsafeMkProps("name");
var muted = $foreign.unsafeMkProps("muted");
var multiple = $foreign.unsafeMkProps("multiple");
var minLength = $foreign.unsafeMkProps("minLength");
var min = $foreign.unsafeMkProps("min");
var method = $foreign.unsafeMkProps("method");
var mediaGroup = $foreign.unsafeMkProps("mediaGroup");
var media = $foreign.unsafeMkProps("media");
var maxLength = $foreign.unsafeMkProps("maxLength");
var max = $foreign.unsafeMkProps("max");
var marginWidth = $foreign.unsafeMkProps("marginWidth");
var marginHeight = $foreign.unsafeMkProps("marginHeight");
var manifest = $foreign.unsafeMkProps("manifest");
var low = $foreign.unsafeMkProps("low");
var loop = $foreign.unsafeMkProps("loop");
var list = $foreign.unsafeMkProps("list");
var lang = $foreign.unsafeMkProps("lang");
var label = $foreign.unsafeMkProps("label");
var kind = $foreign.unsafeMkProps("kind");
var keyType = $foreign.unsafeMkProps("keyType");
var keyParams = $foreign.unsafeMkProps("keyParams");
var key = $foreign.unsafeMkProps("key");
var itemType = $foreign.unsafeMkProps("itemType");
var itemScope = $foreign.unsafeMkProps("itemScope");
var itemRef = $foreign.unsafeMkProps("itemRef");
var itemProp = $foreign.unsafeMkProps("itemProp");
var itemID = $foreign.unsafeMkProps("itemID");
var is = $foreign.unsafeMkProps("is");
var integrity = $foreign.unsafeMkProps("integrity");
var inputMode = $foreign.unsafeMkProps("inputMode");
var inlist = $foreign.unsafeMkProps("inlist");
var icon = $foreign.unsafeMkProps("icon");
var httpEquiv = $foreign.unsafeMkProps("httpEquiv");
var htmlFor = $foreign.unsafeMkProps("htmlFor");
var hrefLang = $foreign.unsafeMkProps("hrefLang");
var href = $foreign.unsafeMkProps("href");
var high = $foreign.unsafeMkProps("high");
var hidden = $foreign.unsafeMkProps("hidden");
var height = $foreign.unsafeMkProps("height");
var headers = $foreign.unsafeMkProps("headers");
var frameBorder = $foreign.unsafeMkProps("frameBorder");
var formTarget = $foreign.unsafeMkProps("formTarget");
var formNoValidate = $foreign.unsafeMkProps("formNoValidate");
var formMethod = $foreign.unsafeMkProps("formMethod");
var formEncType = $foreign.unsafeMkProps("formEncType");
var formAction = $foreign.unsafeMkProps("formAction");
var form = $foreign.unsafeMkProps("form");
var fillOpacity = $foreign.unsafeMkProps("fillOpacity");
var fill = $foreign.unsafeMkProps("fill");
var encType = $foreign.unsafeMkProps("encType");
var draggable = $foreign.unsafeMkProps("draggable");
var download = $foreign.unsafeMkProps("download");
var disabled = $foreign.unsafeMkProps("disabled");
var dir = $foreign.unsafeMkProps("dir");
var defer = $foreign.unsafeMkProps("defer");
var defaultValue = $foreign.unsafeMkProps("defaultValue");
var defaultChecked = $foreign.unsafeMkProps("defaultChecked");
var $$default = $foreign.unsafeMkProps("default");
var dateTime = $foreign.unsafeMkProps("dateTime");
var datatype = $foreign.unsafeMkProps("datatype");
var dangerouslySetInnerHTML = $foreign.unsafeMkProps("dangerouslySetInnerHTML");
var d = $foreign.unsafeMkProps("d");
var cy = $foreign.unsafeMkProps("cy");
var cx = $foreign.unsafeMkProps("cx");
var crossOrigin = $foreign.unsafeMkProps("crossOrigin");
var coords = $foreign.unsafeMkProps("coords");
var controls = $foreign.unsafeMkProps("controls");
var contextMenu = $foreign.unsafeMkProps("contextMenu");
var contentEditable = $foreign.unsafeMkProps("contentEditable");
var content = $foreign.unsafeMkProps("content");
var cols = $foreign.unsafeMkProps("cols");
var color = $foreign.unsafeMkProps("color");
var colSpan = $foreign.unsafeMkProps("colSpan");
var className = $foreign.unsafeMkProps("className");
var classID = $foreign.unsafeMkProps("classID");
var cite = $foreign.unsafeMkProps("cite");
var checked = $foreign.unsafeMkProps("checked");
var charSet = $foreign.unsafeMkProps("charSet");
var challenge = $foreign.unsafeMkProps("checked");
var cellSpacing = $foreign.unsafeMkProps("cellSpacing");
var cellPadding = $foreign.unsafeMkProps("cellPadding");
var capture = $foreign.unsafeMkProps("capture");
var autoSave = $foreign.unsafeMkProps("autoSave");
var autoPlay = $foreign.unsafeMkProps("autoPlay");
var autoFocus = $foreign.unsafeMkProps("autoFocus");
var autoCorrect = $foreign.unsafeMkProps("autoCorrect");
var autoComplete = $foreign.unsafeMkProps("autoComplete");
var autoCapitalize = $foreign.unsafeMkProps("autoCapitalize");
var async = $foreign.unsafeMkProps("async");
var aria = $foreign.unsafePrefixProps("aria-");
var alt = $foreign.unsafeMkProps("alt");
var allowTransparency = $foreign.unsafeMkProps("allowTransparency");
var allowFullScreen = $foreign.unsafeMkProps("allowFullScreen");
var action = $foreign.unsafeMkProps("action");
var accessKey = $foreign.unsafeMkProps("accessKey");
var acceptCharset = $foreign.unsafeMkProps("acceptCharset");
var accept = $foreign.unsafeMkProps("accept");
var about = $foreign.unsafeMkProps("about");
var _type = $foreign.unsafeMkProps("type");
var _id = $foreign.unsafeMkProps("id");
var _data = $foreign.unsafePrefixProps("data-");
module.exports = {
    _data: _data, 
    _id: _id, 
    _type: _type, 
    about: about, 
    accept: accept, 
    acceptCharset: acceptCharset, 
    accessKey: accessKey, 
    action: action, 
    allowFullScreen: allowFullScreen, 
    allowTransparency: allowTransparency, 
    alt: alt, 
    aria: aria, 
    async: async, 
    autoCapitalize: autoCapitalize, 
    autoComplete: autoComplete, 
    autoCorrect: autoCorrect, 
    autoFocus: autoFocus, 
    autoPlay: autoPlay, 
    autoSave: autoSave, 
    capture: capture, 
    cellPadding: cellPadding, 
    cellSpacing: cellSpacing, 
    challenge: challenge, 
    charSet: charSet, 
    checked: checked, 
    cite: cite, 
    classID: classID, 
    className: className, 
    colSpan: colSpan, 
    color: color, 
    cols: cols, 
    content: content, 
    contentEditable: contentEditable, 
    contextMenu: contextMenu, 
    controls: controls, 
    coords: coords, 
    crossOrigin: crossOrigin, 
    cx: cx, 
    cy: cy, 
    d: d, 
    dangerouslySetInnerHTML: dangerouslySetInnerHTML, 
    datatype: datatype, 
    dateTime: dateTime, 
    "default": $$default, 
    defaultChecked: defaultChecked, 
    defaultValue: defaultValue, 
    defer: defer, 
    dir: dir, 
    disabled: disabled, 
    download: download, 
    draggable: draggable, 
    encType: encType, 
    fill: fill, 
    fillOpacity: fillOpacity, 
    form: form, 
    formAction: formAction, 
    formEncType: formEncType, 
    formMethod: formMethod, 
    formNoValidate: formNoValidate, 
    formTarget: formTarget, 
    frameBorder: frameBorder, 
    headers: headers, 
    height: height, 
    hidden: hidden, 
    high: high, 
    href: href, 
    hrefLang: hrefLang, 
    htmlFor: htmlFor, 
    httpEquiv: httpEquiv, 
    icon: icon, 
    inlist: inlist, 
    inputMode: inputMode, 
    integrity: integrity, 
    is: is, 
    itemID: itemID, 
    itemProp: itemProp, 
    itemRef: itemRef, 
    itemScope: itemScope, 
    itemType: itemType, 
    key: key, 
    keyParams: keyParams, 
    keyType: keyType, 
    kind: kind, 
    label: label, 
    lang: lang, 
    list: list, 
    loop: loop, 
    low: low, 
    manifest: manifest, 
    marginHeight: marginHeight, 
    marginWidth: marginWidth, 
    max: max, 
    maxLength: maxLength, 
    media: media, 
    mediaGroup: mediaGroup, 
    method: method, 
    min: min, 
    minLength: minLength, 
    multiple: multiple, 
    muted: muted, 
    name: name, 
    noValidate: noValidate, 
    nonce: nonce, 
    onAnimationEnd: onAnimationEnd, 
    onAnimationIteration: onAnimationIteration, 
    onAnimationStart: onAnimationStart, 
    onBlur: onBlur, 
    onChange: onChange, 
    onClick: onClick, 
    onCopy: onCopy, 
    onCut: onCut, 
    onDoubleClick: onDoubleClick, 
    onDrag: onDrag, 
    onDragEnd: onDragEnd, 
    onDragEnter: onDragEnter, 
    onDragExit: onDragExit, 
    onDragLeave: onDragLeave, 
    onDragOver: onDragOver, 
    onDragStart: onDragStart, 
    onDrop: onDrop, 
    onFocus: onFocus, 
    onInput: onInput, 
    onInvalid: onInvalid, 
    onKeyDown: onKeyDown, 
    onKeyPress: onKeyPress, 
    onKeyUp: onKeyUp, 
    onLoad: onLoad, 
    onMouseDown: onMouseDown, 
    onMouseEnter: onMouseEnter, 
    onMouseLeave: onMouseLeave, 
    onMouseMove: onMouseMove, 
    onMouseOut: onMouseOut, 
    onMouseOver: onMouseOver, 
    onMouseUp: onMouseUp, 
    onPaste: onPaste, 
    onScroll: onScroll, 
    onSubmit: onSubmit, 
    onTouchCancel: onTouchCancel, 
    onTouchEnd: onTouchEnd, 
    onTouchMove: onTouchMove, 
    onTouchStart: onTouchStart, 
    onTransitionEnd: onTransitionEnd, 
    onWheel: onWheel, 
    opacity: opacity, 
    open: open, 
    optimum: optimum, 
    pattern: pattern, 
    placeholder: placeholder, 
    points: points, 
    poster: poster, 
    prefix: prefix, 
    preload: preload, 
    profile: profile, 
    property: property, 
    r: r, 
    radioGroup: radioGroup, 
    readOnly: readOnly, 
    rel: rel, 
    required: required, 
    resource: resource, 
    results: results, 
    reversed: reversed, 
    role: role, 
    rowSpan: rowSpan, 
    rows: rows, 
    sandbox: sandbox, 
    scope: scope, 
    scoped: scoped, 
    scrolling: scrolling, 
    seamless: seamless, 
    security: security, 
    selected: selected, 
    shape: shape, 
    size: size, 
    sizes: sizes, 
    span: span, 
    spellCheck: spellCheck, 
    src: src, 
    srcDoc: srcDoc, 
    srcLang: srcLang, 
    srcSet: srcSet, 
    start: start, 
    step: step, 
    stroke: stroke, 
    strokeWidth: strokeWidth, 
    style: style, 
    summary: summary, 
    suppressContentEditableWarning: suppressContentEditableWarning, 
    tabIndex: tabIndex, 
    target: target, 
    title: title, 
    "typeof": $$typeof, 
    unselectable: unselectable, 
    useMap: useMap, 
    value: value, 
    viewBox: viewBox, 
    vocab: vocab, 
    width: width, 
    wmode: wmode, 
    wrap: wrap, 
    x: x, 
    y: y, 
    unsafeFromPropsArray: $foreign.unsafeFromPropsArray, 
    unsafeMkProps: $foreign.unsafeMkProps, 
    unsafePrefixProps: $foreign.unsafePrefixProps, 
    unsafeUnfoldProps: $foreign.unsafeUnfoldProps
};
